import script from "./Step3Welcome.vue?vue&type=script&setup=true&lang=js"
export * from "./Step3Welcome.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__